import React from 'react';
import { Plane, Train, Car, Bus } from 'lucide-react';

const TransportSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  transportTypes,
  transportHubs
}) => {
  // Функция для получения иконки транспорта
  const getTransportIcon = (type) => {
    switch(type) {
      case 'plane':
        return <Plane className="w-5 h-5 text-blue-500" />;
      case 'train':
        return <Train className="w-5 h-5 text-orange-500" />;
      case 'car':
        return <Car className="w-5 h-5 text-green-500" />;
      case 'bus':
        return <Bus className="w-5 h-5 text-yellow-500" />;
      default:
        return <Plane className="w-5 h-5 text-blue-500" />;
    }
  };

  // Получить текущий выбранный тип транспорта
  const currentTransport = transportTypes.find(t => t.id === formData.transportType) || transportTypes[0];

  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        {getTransportIcon(formData.transportType)}
        <span className="ml-2">Транспорт</span>
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Тип транспорта */}
        <div className="col-span-full">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Выберите тип транспорта
          </label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {transportTypes.map(type => (
              <label 
                key={type.id}
                className={`
                  flex flex-col items-center justify-center p-3 rounded-lg border
                  ${formData.transportType === type.id 
                    ? 'bg-blue-100 border-blue-300 text-blue-700 dark:bg-blue-900/40 dark:border-blue-700 dark:text-blue-300'
                    : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-650'}
                  transition-colors cursor-pointer
                `}
              >
                <input
                  type="radio"
                  name="transportType"
                  value={type.id}
                  checked={formData.transportType === type.id}
                  onChange={handleInputChange}
                  className="sr-only"
                />
                <div className="mb-2">
                  {getTransportIcon(type.id)}
                </div>
                <span className="text-sm font-medium">{type.name}</span>
              </label>
            ))}
          </div>
          {errors.transportType && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.transportType}
            </p>
          )}
        </div>

        {/* Билет туда-обратно */}
        <div className="col-span-full">
          <label className="flex items-center">
            <input
              type="checkbox"
              name="includeReturnTicket"
              checked={formData.includeReturnTicket}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Билет туда-обратно
            </span>
          </label>
        </div>

        {/* Класс обслуживания */}
        <div>
          <label htmlFor="transportClass" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Класс обслуживания
          </label>
          <select
            id="transportClass"
            name="transportClass"
            value={formData.transportClass}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            <option value="economy">Эконом</option>
            <option value="comfort">Комфорт</option>
            <option value="business">Бизнес</option>
          </select>
        </div>
      </div>

      {/* Информация о выбранном транспорте */}
      <div className="mt-4 bg-white dark:bg-gray-700 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
        <div className="flex items-start">
          {getTransportIcon(formData.transportType)}
          <div className="ml-3">
            <h4 className="text-sm font-medium text-gray-900 dark:text-white">
              {currentTransport.name}
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
              {formData.transportType === 'plane' && 'Самый быстрый способ путешествия, но обычно и самый дорогой. Идеально для дальних поездок.'}
              {formData.transportType === 'train' && 'Комфортный способ путешествия на средние расстояния. Позволяет наслаждаться пейзажами в пути.'}
              {formData.transportType === 'car' && 'Гибкий вариант для самостоятельных путешественников. Дает свободу перемещения и остановок в пути.'}
              {formData.transportType === 'bus' && 'Экономичный вариант для поездок на короткие и средние расстояния. Подходит для бюджетных путешествий.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransportSection;